import React from 'react';
import './index.scss';
import {
    Box,
    BoxedRow,
    Text6,
    Image,
    Circle,
    IconRouterRegular,
    skinVars,
    IconPlugRegular,
    IconOpticalFiberRegular,
    IconChevronLeftRegular,
    NavigationBar,
    Text2,
    ThemeVariant,
    useWindowSize,
} from '@telefonica/mistica';
import { t } from 'i18next';
import { isWebviewAndroid, isWebviewIOS } from '../../../../../utils/navigation/controlDevices';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BreadCrumbsWrapper from '../../../../../components/BreadcrumbsWrapper';

interface IRowsRequiredEquipment {
    asset: any;
    title: string;
    image: any;
}

export const RequiredEquipmentTransfer: React.FC = () => {
    const navigate = useNavigate();
    const size = useWindowSize();
    const [params] = useSearchParams();

    const rows: IRowsRequiredEquipment[] = [
        {
            asset: (
                <Circle size={40} backgroundColor={skinVars.colors.brandLow}>
                    <IconRouterRegular size={20} color={skinVars.colors.brand} />
                </Circle>
            ),
            title: t('router'),
            image: (
                <Image
                    src={'https://dlvt1u0vrr0ux.cloudfront.net/media/public/router.png'}
                    width={115}
                    height={63}
                    aspectRatio='16:9'
                />
            ),
        },
        {
            asset: (
                <Circle size={40} backgroundColor={skinVars.colors.brandLow}>
                    <IconPlugRegular size={20} color={skinVars.colors.brand} />
                </Circle>
            ),
            title: t('adapter'),
            image: (
                <Image
                    src={'https://dlvt1u0vrr0ux.cloudfront.net/media/public/adaptador.png'}
                    width={115}
                    height={63}
                    aspectRatio='16:9'
                />
            ),
        },
        {
            asset: (
                <Circle size={40} backgroundColor={skinVars.colors.brandLow}>
                    <IconOpticalFiberRegular size={20} color={skinVars.colors.brand} />
                </Circle>
            ),
            title: t('ethernetCable'),
            image: (
                <Image
                    src={'https://dlvt1u0vrr0ux.cloudfront.net/media/public/cable.png'}
                    width={115}
                    height={63}
                    aspectRatio='16:9'
                />
            ),
        },
    ];
    return (
        <>
            <div
                className='RequiredEquipmentTransfer-page__header'
                style={{ background: skinVars.colors.navigationBarBackground }}
            >
                {!(isWebviewAndroid || isWebviewIOS) && (
                    <>
                        <div className='RequiredEquipmentTransfer-page__header-navigationBar'>
                            <NavigationBar
                                isInverse={true}
                                onBack={() => {
                                    navigate(-1);
                                }}
                                title={t('transferInformation')}
                            />
                        </div>

                        <div className='RequiredEquipmentTransfer-page__header-return'>
                            <div
                                className='RequiredEquipmentTransfer-page__header-return-cursor'
                                onClick={() => {
                                    navigate(-1);
                                }}
                            >
                                <div className='RequiredEquipmentTransfer-page__header-return-icon'>
                                    <IconChevronLeftRegular color={skinVars.colors.appBarBackground} size={20} />
                                </div>
                                <Text2 medium color={skinVars.colors.appBarBackground}>
                                    {t('returnResponsive')}
                                </Text2>
                            </div>
                        </div>
                    </>
                )}
                <div
                    className='RequiredEquipmentTransfer-page__header-breadcrumbs'
                    style={{ background: skinVars.colors.backgroundBrand }}
                >
                    <ThemeVariant isInverse>
                        <BreadCrumbsWrapper
                            title={t('transferInformation')}
                            breadcrumbs={[
                                { title: t('profileOrders'), url: '/profile/orders' },
                                { title: t('orderDetail'), url: `/order-detail?id=${params.get('id')}` },
                            ]}
                        />
                    </ThemeVariant>
                </div>
            </div>
            <div className='RequiredEquipmentTransfer-page__title'>
                <Text6>{t('rememberToTake')}</Text6>
            </div>
            {rows.map((row: IRowsRequiredEquipment, index) => (
                <div
                    key={index}
                    style={{
                        margin:
                            size.width >= 1220
                                ? '0 416px 24px 104px'
                                : size.width >= 1024 && size.width < 1220
                                ? '0 136px 24px 40px'
                                : size.width >= 768 && size.width < 1024
                                ? '0 384px 16px 32px'
                                : '16px',
                    }}
                >
                    <BoxedRow asset={row.asset} title={row.title} right={row.image}></BoxedRow>
                </div>
            ))}
        </>
    );
};

export default RequiredEquipmentTransfer;
